export default __webpack_public_path__ + "static/sendemeldung_de-2d185e9c0ae78c7d609070aac82d81eb.svg";